<div class="load-lazy" *ngIf="lazyshow">
  <!-- <div class="loader-outer"><div class="loader">Loading...</div></div> -->
  <img src="assets/img/loaderbx.gif" alt="Loading...">
</div>
